<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="headline font-weight-bold mb-4">
          {{ $t("subscriptions.title") }}
        </div>
      </v-col>
    </v-row>

    <template>
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="3"
          lg="3"
          v-for="(stat, i) in Object.keys(subscriptionCounts)"
          :key="i"
        >
          <v-card
            class="rounded-card"
            :outlined="subscriptionTable.state === stat ? false : true"
          >
            <v-card-title
              class="subtitle-2 font-weight-bold grey--text text--darken-1"
            >
              {{ getCardName(stat) }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text
              ref="card-currency-total-amount"
              class="headline font-weight-medium text-right green--text text--accent-4"
            >
              {{ getCardValue(stat) }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <SubscriptionsTable
      :loading="loading"
      :table="subscriptionTable"
      :startDate="startDate"
      :endDate="endDate"
      :headers="headers"
      :statuses="statuses"
      @get-subscriptions="
        (startDate, endDate) => {
          if (startDate) {
            endDate = $moment().format('YYYY-MM-DD');
            getsubscriptionsWithFilters(startDate, endDate);
          } else {
            getsubscriptionsWithFilters();
          }
        }
      "
      @update-dates="(property, date) => updateDates(property, date)"
      @table-pagination="subscriptionTable.pagination = $event"
      @open="open($event)"
    />
    <v-navigation-drawer
      :value="isSubscriptionDetailsOpen"
      @input="inputSubscriptionDetails"
      :width="'calc(100vw - 200px)'"
      temporary
      fixed
      right
      color="grey lighten-3"
      style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
    >
      <Details
        v-if="isSubscriptionDetailsOpen"
        :subscription="subscription"
        @close="closeSubscriptionsDetails()"
      />
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import SubscriptionsTable from "@/components/Subscriptions/SubscriptionsTable";
import Details from "@/components/Subscriptions/SubscriptionsDetails";
import donationMixin from "@/mixins/donations";
export default {
  name: "subscriptions",
  components: { SubscriptionsTable, Details },
  mixins: [donationMixin],
  data() {
    return {
      subscriptionTable: {
        items: [],
        search: null,
        total: 0,
        state: null,
        gateway: null,
        pagination: {
          sortBy: ["created_at"],
          sortDesc: [true],
          itemsPerPage: 25,
          mustSort: true,
          multiSort: false
        },
        headers: [
          {
            text: "Subscription ID",
            value: "Subscription ID",
            align: "left",
            sortable: false,
            class: "blue--text text--darken-4"
          },
          {
            text: this.$t("subscriptions.dashboard.organization_name"),
            value: "organization_name",
            align: "left",
            sortable: false,
            class: "blue--text text--darken-4"
          },
          {
            text: this.$t("subscriptions.dashboard.status"),
            value: "state",
            align: "left",
            sortable: false,
            class: "blue--text text--darken-4"
          },
          {
            text: this.$t("subscriptions.dashboard.timestamp"),
            value: "created_at",
            align: "left",
            sortable: true,
            class: "blue--text text--darken-4"
          },
          {
            text: this.$t("subscriptions.dashboard.total_amount"),
            value: "total_amount",
            align: "left",
            sortable: false,
            class: "blue--text text--darken-4"
          },
          {
            text: this.$t("subscriptions.dashboard.gateway"),
            value: "gateway",
            align: "left",
            sortable: false,
            class: "blue--text text--darken-4"
          },
          {
            text: this.$t("subscriptions.dashboard.next_payment"),
            value: "next_payment",
            align: "left",
            sortable: false,
            class: "blue--text text--darken-4"
          },
          // {
          //   text: this.$t("subscriptions.dashboard.collected"),
          //   value: "collected",
          //   align: "left",
          //   sortable: false,
          //   class: "blue--text text--darken-4"
          // },
          // {
          //   text: this.$t("subscriptions.dashboard.remaining"),
          //   value: "remaining",
          //   align: "left",
          //   sortable: false,
          //   class: "blue--text text--darken-4"
          // },
          {
            text: "",
            value: "",
            align: "start",
            sortable: false,
            class: "text-no-wrap blue--text text--darken-4",
            width: "0px"
          }
        ]
      },
      gateways: [],
      initialDateEnv: "2019-01-01",
      startDate: null,
      endDate: this.$moment()
        .endOf("day")
        .format("YYYY-MM-DD"),
      statuses: [
        "active",
        "success",
        "failed",
        "cancel",
        "pending",
        "trialing",
        "refused",
        "refunded"
      ],
      loading: false
    };
  },
  computed: {
    ...mapState({
      subscriptions: ({ subscriptions: { subscriptions } }) => subscriptions,
      subscriptionsTotal: ({ subscriptionsTotal: { subscriptionsTotal } }) =>
        subscriptionsTotal,
      isSubscriptionDetailsOpen: ({
        subscriptions: { isSubscriptionDetailsOpen }
      }) => isSubscriptionDetailsOpen,
      subscription: ({ subscriptions: { subscriptionSelected } }) =>
        subscriptionSelected,
      subscriptionCounts: ({ subscriptions: { subscriptionCounts } }) =>
        subscriptionCounts
    }),
    ...mapGetters({
      subscriptions: "subscriptions/subscriptions",
      subscriptionsTotal: "subscriptions/subscriptionsTotal"
    }),
    headers() {
      let { headers } = this.subscriptionTable;
      return headers;
    }
  },
  watch: {
    "subscriptionTable.pagination": {
      handler() {
        this.getsubscriptionsWithFilters();
      },
      deep: true
    },
    "subscriptionTable.gateway": {
      handler() {
        this.getsubscriptionsWithFilters();
      },
      deep: true
    }
  },
  created() {
    this.startDate = this.$moment(this.initialDateEnv).format("YYYY-MM-DD");
    this.getSubscriptionCounts();
  },
  methods: {
    ...mapActions({
      getSubscriptions: "subscriptions/getSubscriptions",
      openSubscriptionDetails: "subscriptions/openSubscriptionDetails",
      getSubscriptionCounts: "subscriptions/getSubscriptionCounts"
    }),
    ...mapMutations({
      closeSubscriptionsDetails: "subscriptions/closeSubscriptionsDetails"
    }),
    getCardName(key) {
      let state = key.split("_count")[0];
      return this.getStateByName(state);
    },
    getCardValue(key) {
      return this.subscriptionCounts[key];
    },
    inputSubscriptionDetails(arg) {
      if (!arg) {
        this.closeSubscriptionsDetails();
      }
    },
    updateDates(property, date) {
      this[property] = date;
      this.getsubscriptionsWithFilters();
    },
    async getsubscriptionsWithFilters(startDate, endDate) {
      const initialDate = !startDate ? this.startDate : startDate;
      const finalDate = !endDate ? this.endDate : endDate;
      this.startDate = initialDate;
      this.loading = true;
      let { sortBy, sortDesc = false } = this.subscriptionTable.pagination;
      const { page, itemsPerPage } = this.subscriptionTable.pagination;
      if (Array.isArray(sortBy)) {
        [sortBy] = sortBy;
      }
      if (Array.isArray(sortDesc)) {
        [sortDesc] = sortDesc;
      }

      await this.getSubscriptions({
        startDate: initialDate,
        endDate: finalDate,
        search: this.subscriptionTable.search,
        page,
        rowsPerPage: itemsPerPage,
        sortBy: sortBy || "id",
        descending: sortDesc,
        state: this.subscriptionTable.state
          ? this.getStateValueByName(
              this.subscriptionTable.state.split("Count")[0]
            )
          : null,
        gateway: this.subscriptionTable.gateway
      });
      this.loading = false;
      this.subscriptionTable.items = this.subscriptions;
      this.subscriptionTable.total = Number.parseInt(
        this.subscriptionsTotal,
        10
      );
    },
    open(id) {
      this.openSubscriptionDetails(id);
    }
  }
};
</script>

<style lang="scss" scoped></style>
